import { render, staticRenderFns } from "./UploadPicCom.vue?vue&type=template&id=7acdfdf7&"
import script from "./UploadPicCom.vue?vue&type=script&lang=ts&"
export * from "./UploadPicCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports